// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import PropTypes from 'prop-types'
import { TrackingProvider } from '@indeed/flex-tracking-context'

import EmployerNetworkDetail from 'syft-acp-core/entities/EmployerDetail/EmployerNetworkDetail'
import SubNavigation from 'syft-acp-core/components/Navigation/SubNavigation'
import PageTitle, { recordLabel, useEmployerName } from 'syft-acp-core/components/PageTitle'

const EmployerNetworkView = ({ match: { params } }) => {
  const employerName = useEmployerName(Number(params.id))

  return (
    <TrackingProvider
      value={{
        context: {
          employer_id: Number(params.id),
          network_id: Number(params.networkID),
        },
      }}
    >
      <PageTitle title={[`Network ${params.networkID}`, recordLabel('Employer', params.id, employerName)]}>
        <SubNavigation subPage="employers" data={{ employerID: Number(params.id) }} />
        <EmployerNetworkDetail id={Number(params.networkID)} employerID={Number(params.id)} />
      </PageTitle>
    </TrackingProvider>
  )
}

EmployerNetworkView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      // Note: ID gets passed as a string directly from the URL.
      id: PropTypes.string.isRequired,
      networkID: PropTypes.string.isRequired,
    }).isRequired,
  }),
}

export default EmployerNetworkView
